import { gql, useMutation } from '@apollo/client';
import {
  BrandKey,
  TagBrandedContentCreationWithoutTagInput,
  TagBrandedContentStatus,
  TagCreationInput,
  TagLang,
  TagType,
} from '../../__generated__/queries-web';

const CREATE_TAG = gql`
  mutation CreateTag($data: TagCreationInput!) {
    createTag(data: $data) {
      id
    }
  }
`;

interface CreateTagMutation {
  createTag: {
    id: string;
  };
}

interface CreateTagMutationVariables {
  data: TagCreationInput;
}

interface CreateTagFormInput {
  id: string;
  title: string;
  type: TagType;
  lang: TagLang;
  brandKey: BrandKey;
  body?: TagBrandedContentCreationWithoutTagInput['body'];
  media?: TagBrandedContentCreationWithoutTagInput['media'];
}

export const toCreateTagInput = ({
  id,
  title,
  type,
  lang,
  brandKey,
  body,
  media,
}: CreateTagFormInput): TagCreationInput => ({
  id,
  title: title.trim(),
  type,
  lang,
  brandedContents: {
    create: [
      {
        brandKey,
        status: TagBrandedContentStatus.Published,
        ...(body ? { body } : {}),
        ...(media ? { media } : {}),
      },
    ],
  },
});

export const useCreateTag = () =>
  useMutation<CreateTagMutation, CreateTagMutationVariables>(CREATE_TAG);
